<div class="track-wrapper">

  @for (state of statusList; track $index) {

    <div
      class="state"
      [ngClass]="{ 'done': state.done, 'current': state.current }"
      (click)="showStateDescription(state)"
    >
      <div class="state-number"></div>
      <div class="label">{{ state.nombre }}</div>
    </div>

  }

  <div class="track-line-bg"></div>

  <div
    class="track-line-progress"
    [style.width]="'calc(' + trackLineProgressWidth + '% - ' + (trackLineProgressWidth !== 100 ? '15' : '40') + 'px)'"
  ></div>

</div>
